import { useEffect, useState } from "react";
import { initial } from "../../../common/domain/RemoteData.model";
import { remoteDataWithSetter } from "../../../common/utils/remoteDataWithSetter";
import { fetchAllBis } from "../infrastructure/CatalogService";
import {useFilterContext} from "../infrastructure/FilterContext";

export const useCatalogFacade = () => {
    const { filterOptionsRemoteData, filters, updateFilters } = useFilterContext();
    const [catalogRemoteData, setCatalogRemoteData] = useState(initial(null));
    const [page, setPage] = useState(0);
    const [viewMode, setViewMode] = useState("grid");

    useEffect(() => {
        const fetchCatalog = async () => {
            const result = () => fetchAllBis(filters, { page, amount: 20 });
            await remoteDataWithSetter(setCatalogRemoteData, result);
        };
        fetchCatalog();
    }, [filters, page]);

    const onViewModeChange = (mode) => setViewMode(mode);

    const onFilterChange = (newFilters) => {
        updateFilters(newFilters);
        setPage(0);
    };

    const onPageChange = (newPage) => {
        setPage(newPage);
    };

    return {
        filterOptionsRemoteData,
        filter: filters,
        catalogRemoteData,
        viewMode,
        onViewModeChange,
        onFilterChange,
        onPageChange
    };
};
